import DataSetCardOverviewTab from './DataSetCardOverviewTab';

export default DataSetCardOverviewTab;
